import { FC } from "react";

interface IconProps {
  color?: string;
  filled?: boolean;
}

const RoundedInfo: FC<IconProps> = ({ color = "#DC787B", filled = true }) => (
  <svg
    viewBox="0 0 16 16"
    fill={filled ? color : "none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M8 1.833a6.167 6.167 0 1 1 0 12.334A6.167 6.167 0 0 1 8 1.833Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.997 5.47v2.945"
      stroke={filled ? "#fff" : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.998 10.53h.007"
      stroke={filled ? "#fff" : color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RoundedInfo;
